import { AxiosResponse } from 'axios';

import { HttpClient } from 'api/HttpClient';
import { EmailNotificationEvent } from 'common/enums/emailNotifications.enums';

import { UserEmailNotificationsResponseDto } from './userEmailNotifications.dto';

export class UserEmailNotificationsApi extends HttpClient {
  public constructor() {
    super(process.env.REACT_APP_API_URL + '/user-email-notifications');
  }

  public async getNotifications() {
    return await this.instance
      .get('/')
      .then((response: AxiosResponse<UserEmailNotificationsResponseDto>) => response.data);
  }

  async createNotifications(events: EmailNotificationEvent[]): Promise<void> {
    await this.instance.post('/', { events: events });
  }

  async updateNotifications(events: EmailNotificationEvent[]): Promise<void> {
    await this.instance.patch(``, { events: events });
  }
}
